import { render } from "./EditCollectionSourcesModal.vue?vue&type=template&id=2cf5289a&scoped=true"
import script from "./EditCollectionSourcesModal.vue?vue&type=script&lang=js"
export * from "./EditCollectionSourcesModal.vue?vue&type=script&lang=js"

import "./EditCollectionSourcesModal.vue?vue&type=style&index=0&id=2cf5289a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf5289a"]])

export default __exports__